/*global google*/
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import _ from "underscore";

import '../../assets/css/common.css';
import '../../assets/css/sidemenu.css';
import '../../assets/css/timesheet.css';

import NavBar from "../../components/nav-bar";
import SideBar from "../../components/sidebar";

import {
    APIProvider, Map, AdvancedMarker, useMapsLibrary, useMap
} from '@vis.gl/react-google-maps';

import TruckLogo from "../../assets/images/map-markers/delivery-truck.png";
import CustomerLogo from "../../assets/images/map-markers/customer.png";
import PlantLogo from "../../assets/images/map-markers/warehouse.png";
import { MovingMarker } from "./moving-maker";

function RoutingMap() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [customerLocation, setCustomerLocation] = useState(null);
    const [plantLocation, setPlantLocation] = useState(null);
    const [vehicleLocation, setVehicleLocation] = useState(null);
    const [plantsLocation, setPlantsLocation] = useState([]);

    useEffect(() => {
        const cus = searchParams.get("cus").split(",");
        const customerLoc = {
            lat: parseFloat(cus[0]),
            lng: parseFloat(cus[1])
        };
        setCustomerLocation(customerLoc);

        const plt = searchParams.get("plt").split(",");
        const plantLoc = {
            lat: parseFloat(plt[0]),
            lng: parseFloat(plt[1])
        };
        setPlantLocation(plantLoc);

        const plts = searchParams.get("plt").split(";");
        const a = _.map(plts, function (b) {
            const c = b.split(",");
            return {
                lat: parseFloat(c[0]),
                lng: parseFloat(c[1])
            };
        });
        setPlantsLocation(a);

        const veh = searchParams.get("veh").split(",");
        const vehicleLoc = {
            lat: parseFloat(veh[0]),
            lng: parseFloat(veh[1])
        };
        setVehicleLocation(vehicleLoc);
    }, [searchParams]);

    return (
        <div className="container-fluid px-0 mb-5">
            <main id="main-layout" role="main" className="pb-3">
                <div className="enquiry-page-wrapper">
                    <NavBar title={"Routing"} />
                    <div className="container-fluid">
                        <div className="row">
                            <SideBar />

                            <div className="home-section">
                                <div className="col-lg-12 mb-2 pb-2" id="logContainer">
                                    {/* <div className="row m-0 justify-content-between align-items-center">
                                        <div className="card-header p-0" style={{ borderBottom: "none" }}>
                                            <ul className="nav nav-tabs justify-content-start common-view-tabs" role="tablist">
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link active common-view-link" data-status-id="0"
                                                        id="nav-Current-tab" data-toggle="tab" href="#nav-Current"
                                                        role="tab" aria-controls="nav-Current"
                                                        aria-selected="true">Scheduler</a>
                                                </li>
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link common-view-link" data-status-id="1"
                                                        id="nav-History-tab" data-toggle="tab" href="#nav-History"
                                                        role="tab" aria-controls="nav-History"
                                                        aria-selected="true">History</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6 top-right d-flex justify-content-end align-items-end"
                                            style={{ gap: "10px" }}>
                                            <div className="container-fluid">
                                                <input className="Enquiry-form-control" type="search" id="searchInput"
                                                    placeholder="Search by Process" />
                                            </div>
                                            <div className="d-flex" style={{ gap: "10px" }}>
                                                <div>
                                                    <a role="button" className="c-black" href="/temp/Production Schedule.xlsx"
                                                        title="Download Report">
                                                        <i className="f-24 i-btn cursor-pointer ti ti-download"></i>
                                                    </a>
                                                </div>
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Filter" onClick="openSideFilterPanel()">
                                                    <i id="filter-icon" className="f-24 i-btn cursor-pointer ti ti-filter"></i>
                                                </a>
                                            </div>
                                            <div id="plan-insert-record">
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip" title="Add"
                                                    onClick="insertRowSchedule()">
                                                    <i className="f-24 i-btn cursor-pointer ti ti-table-plus"></i>
                                                </a>
                                            </div>
                                            <div id="plan-upload-record">
                                                <input type="file" id="excelFileInput" accept=".xlsx, .xls"
                                                    style={{ display: "none" }} onchange="excelFileUpload()" />
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Upload"
                                                    onClick="document.getElementById('excelFileInput').click();">
                                                    <i className="f-24 i-btn cursor-pointer ti ti-upload"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="tab-content mt-1" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-Current" role="tabpanel"
                                            aria-labelledby="nav-Current-tab">
                                            <div id="list_content" className="table-responsive">
                                                <APIProvider apiKey={"AIzaSyA1lKsIAU_HCDporvGGFRYWRFYTFAd16oE"}>
                                                    <Map
                                                        mapId={"2b642ce67b90ea69"}
                                                        style={{ width: '100%', height: 'calc(100vh - 150px)' }}
                                                        defaultCenter={customerLocation}
                                                        defaultZoom={5}
                                                        gestureHandling={'greedy'}
                                                        disableDefaultUI={true}
                                                    >
                                                        {/* Cutomer marker */}
                                                        <AdvancedMarker position={customerLocation}>
                                                            <img src={CustomerLogo} width={48} height={48} />
                                                        </AdvancedMarker>

                                                        {/* Plant marker */}
                                                        <AdvancedMarker position={plantLocation}>
                                                            <img src={PlantLogo} width={48} height={48} />
                                                        </AdvancedMarker>

                                                        {plantsLocation.map((pt, index) => (
                                                            // < key={`plant-location` + index}>
                                                            <AdvancedMarker position={pt} key={`plant-location` + index}>
                                                                <img src={PlantLogo} width={48} height={48} />
                                                            </AdvancedMarker>
                                                            // </>
                                                        ))}

                                                        {/* Vehicle marker */}
                                                        <AdvancedMarker position={vehicleLocation}>
                                                            <img src={TruckLogo} width={48} height={48} />
                                                        </AdvancedMarker>

                                                        <Directions vehicleLocation={vehicleLocation} plantsLocation={plantsLocation} customerLocation={customerLocation} />
                                                        <MovingMarker />
                                                    </Map>
                                                </APIProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>

    );
}

function Directions(props) {
    const map = useMap();
    const routesLibrary = useMapsLibrary('routes');
    const [directionsService, setDirectionsService] = useState();
    const [directionsRenderer, setDirectionsRenderer] = useState();
    const [routes, setRoutes] = useState([]);
    const [routeIndex, setRouteIndex] = useState(0);
    const selected = routes[routeIndex];
    const leg = selected?.legs[0];

    // Initialize directions service and renderer
    useEffect(() => {
        if (!routesLibrary || !map) return;
        setDirectionsService(new routesLibrary.DirectionsService());
        setDirectionsRenderer(new routesLibrary.DirectionsRenderer({ map, suppressMarkers: true }));
    }, [routesLibrary, map]);

    // Use directions service
    useEffect(() => {
        if (!directionsService || !directionsRenderer) return;

        const wp = _.map(props.plantsLocation, function (a) {
            return { location: a, stopover: true }
        });

        directionsService
            .route({
                origin: props.vehicleLocation,
                destination: props.customerLocation,
                waypoints: wp,
                travelMode: google.maps.TravelMode.DRIVING,
                provideRouteAlternatives: true,
            })
            .then(response => {
                var overview_path = response.routes[0].overview_path;
                // for (var i = 0; i < overview_path.length; i++) {
                //     console.log("latitude=" + overview_path[i].lat() + ", longitude=" + overview_path[i].lng())
                // }
                directionsRenderer.setDirections(response);
                setRoutes(response.routes);
            });

        return () => directionsRenderer.setMap(null);
    }, [directionsService, directionsRenderer]);

    // Update direction route
    useEffect(() => {
        if (!directionsRenderer) return;
        directionsRenderer.setRouteIndex(routeIndex);
    }, [routeIndex, directionsRenderer]);

    if (!leg) return null;

    return (
        <div className="directions">
            <h2>{selected.summary}</h2>
            <p>
                {leg.start_address.split(',')[0]} to {leg.end_address.split(',')[0]}
            </p>
            <p>Distance: {leg.distance?.text}</p>
            <p>Duration: {leg.duration?.text}</p>
            {routes.length > 1 &&
                <>
                    <h2>Other Routes</h2>
                    <ul>
                        {routes.map((route, index) => (
                            <li key={route.summary}>
                                <button onClick={() => setRouteIndex(index)}>
                                    {route.summary}
                                </button>
                            </li>
                        ))}
                    </ul>
                </>
            }
        </div>
    );
}

export default RoutingMap;